import Flickity from 'flickity';

/**
 * Flickity equal slides height hack
 * https://codepen.io/desandro/pen/ZXEGVq
 * Used mainly for products carousels to make sure product cards have same height and elements align horizontally
 */

export const initFlickityResizeClass = () => {
  Flickity.prototype._createResizeClass = function () {
    this.element.classList.add('flickity-resize');
  };

  Flickity.createMethods.push('_createResizeClass');

  const resize = Flickity.prototype.resize;
  Flickity.prototype.resize = function () {
    this.element.classList.remove('flickity-resize');
    resize.call(this);
    this.element.classList.add('flickity-resize');
  };
};
